module.exports = __webpack_public_path__ + "static/media/stakingImage.04989aab.png";